import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const TableLegend = ({ tabKeys, dictionary }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        icon="pi pi-info-circle"
        onClick={() => setVisible(true)}
        label={dictionary.user_logs_table_tabkeys_header}
      />

      <Dialog
        header={dictionary.user_logs_table_tabkeys_header}
        visible={visible}
        style={{ width: '25%' }}
        onHide={() => setVisible(false)}
        position={'bottom-left'}
        className="dialog-keys-wrapper"
      >
        <ul>
          {tabKeys.map((obj, i) => (
            <li key={i}>
              <div className={'key-circle cir_' + i}></div>
              <span>{obj.name}</span>
            </li>
          ))}
        </ul>
      </Dialog>
    </>
  );
};

export default TableLegend;
